import { IResponse } from '@microsoft/portal-app/lib/ajax-utils';
import { createAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import { map } from 'rxjs/operators';
import { getRevokeLinkedInApiUrl } from '../../../redux/modules/accountApis';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { IService } from '../../models/IService';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';
import {
  linkedInDescription,
  linkedInHelpLink,
  linkedInHelpText,
  linkedInRevokeText,
  linkedInServiceId,
  linkedInServiceName
} from './getLinkedInStatus';

export const revokeLinkedIn = (ajax: AjaxCreationMethod) =>
  ajax({
    method: 'POST',
    ...getRevokeLinkedInApiUrl()
  }).pipe(map((payload: IResponse<boolean>) => payload.response));

registry.addEpic(PrivacyActions.revokeLinkedIn, createAjaxEpic(PrivacyActions.revokeLinkedIn, revokeLinkedIn));

export const revokeLinkedInResponse = (state: IPrivacyState, action: IPrivacyAction<boolean>): IPrivacyState => {
  if (action.payload === undefined || action.payload === false) {
    return state;
  }

  if (state.linkedInService === undefined) {
    return state;
  }

  let services: IService = state.linkedInService;

  if (services.serviceName === linkedInServiceName) {
    let nextState: IPrivacyState = {
      ...state,
      linkedInService: {
        serviceName: linkedInServiceName,
        serviceId: linkedInServiceId,
        // Revoke permissions by setting enabled to false to not show in Services list
        enabled: false,
        localizedDescription: linkedInDescription,
        localizedRevokeText: linkedInRevokeText,
        revokeAction: 'revokeLinkedIn',
        helpLinkHref: linkedInHelpLink,
        localizedHelpText: linkedInHelpText
      } as IService
    };
    return nextState;
  } else {
    return state;
  }
};
registry.add(PrivacyActions.revokeLinkedInResponse, revokeLinkedInResponse);
